<template>
  <header class="navigation">
    <!-- Mobile Header - Hidden -->
    <div class="mobile-nav-container">
      <button
        :class="['hamburger', 'hamburger--spin', navOpen ? 'is-active' : '']"
        type="button"
        @click="navOpen = !navOpen"
      >
        <span class="hamburger-box">
          <span class="hamburger-inner"></span>
        </span>
      </button>

      <nav v-if="navOpen">
        <ul>
          <li :class="['nav-item', activeLink === 'about' ? 'active' : '']">
            <a href="#" @click="scrollTo('.about'); activeLink = 'about'">About</a>
          </li>
          <li :class="['nav-item', activeLink === 'work' ? 'active' : '']">
            <a href="#" @click="scrollTo('.work-container'); activeLink = 'work'">Work</a>
          </li>
          <li :class="['nav-item', activeLink === 'reviews' ? 'active' : '']">
            <a href="#" @click="scrollTo('.review'); activeLink = 'reviews'">Reviews</a>
          </li>
          <li :class="['nav-item', activeLink === 'contact' ? 'active' : '']">
            <a href="#" @click="scrollTo('.contact-us'); activeLink = 'contact'">Contact Us</a>
          </li>
        </ul>
      </nav>
      <img src="img/logo2.png" alt="WireToWire Logo">
    </div>

    <!-- Desktop Header -->
    <div class="nav-container">
      <img src="img/logo2.png" alt="WireToWire Logo">
      <!-- Logo End -->
      <nav>
        <ul>
          <li
            :class="['nav-item', activeLink === 'about' ? 'active' : '']"
            @click="scrollTo('.about'); activeLink = 'about';"
          >
            <a href="#">About</a>
          </li>
          <li
            :class="['nav-item', activeLink === 'work' ? 'active' : '']"
            @click="scrollTo('.work-container'); activeLink = 'work'"
          >
            <a href="#">Work</a>
          </li>
          <li
            :class="['nav-item', activeLink === 'reviews' ? 'active' : '']"
            @click="scrollTo('.review'); activeLink = 'reviews'"
          >
            <a href="#">Reviews</a>
          </li>
          <li class>
            <a href="#" class="gallery">Gallery</a>
          </li>
          <li
            :class="['nav-item', activeLink === 'contact' ? 'active' : '']"
            @click="scrollTo('.contact-us'); activeLink = 'contact'"
          >
            <a href="#">Contact Us</a>
          </li>
        </ul>
      </nav>
      <!-- Nav End -->
    </div>
    <!-- Nav Container End -->
  </header>
</template>

<script>
export default {
  name: 'Navigation',
  data() {
    return {
      navOpen: false,
      activeLink: 'about',
    };
  },
  methods: {
    scrollTo(el) {
      // eslint-disable-next-line
      $('html, body')
        .stop()
        .animate(
          {
            // eslint-disable-next-line
            scrollTop: $(`${el}`).offset().top,
          },
          400
        );
    },
  },
};
</script>

<style scoped lang="scss"></style>
